import { MapLocation } from 'app/agriculture/queries/types/MapLocation';

import { Cartesian2, Cartographic, Math } from 'cesium';

export function mousePositionToLocation(
    mouseX: number,
    mouseY: number,
    viewer: Cesium.Viewer,
): MapLocation | undefined {
    const pickRay = viewer.scene.camera.getPickRay(new Cartesian2(mouseX, mouseY));
    if (!pickRay) return undefined;
    const cartesian = viewer.scene.globe.pick(pickRay, viewer.scene);
    if (cartesian) {
        const cartographic = Cartographic.fromCartesian(cartesian);
        const longitude = Math.toDegrees(cartographic.longitude);
        const latitude = Math.toDegrees(cartographic.latitude);

        return { longitude, latitude };
    }
    return undefined;
}

export function disableScreenPan(viewer: Cesium.Viewer) {
    viewer.scene.screenSpaceCameraController.inertiaSpin = 0;
    viewer.scene.screenSpaceCameraController.enableRotate = false;
}

export function enableScreenPan(viewer: Cesium.Viewer) {
    viewer.scene.screenSpaceCameraController.inertiaSpin = 0.9;
    viewer.scene.screenSpaceCameraController.enableRotate = true;
}

export function getWorldPositionFromScreenPosition(
    viewer: Cesium.Viewer,
    position: Cesium.Cartesian2,
) {
    const pickRay = viewer.scene.camera.getPickRay(position);
    if (!pickRay) return undefined;
    return viewer.scene.globe.pick(pickRay, viewer.scene);
}
